export default __webpack_public_path__ + "static/media/editCarImage.eec58119.png";